
import React from "react";
import { CommentsIcon, QuestionsIcon } from "../../Icons/IconPackage/Message";
import { PollsIcon } from "../../Icons/IconPackage/Polls";
import { useCommentsContext } from "../../../context/CommentsContext";
import { useQuestionsContext } from "../../../context/QuestionsContext";
import { usePollsContext } from "../../../context/PollsContext";
import { useLocaleContext } from "../../../context/LocaleContext";
import { useApplicationContext } from "../../../context/ApplicationContext";
import "./style.scss";

export const MODULE_COMMENTS = 'comments';
export const MODULE_QUESTIONS = 'questions';
export const MODULE_POLLS = 'polls';

const Tab = ({ name, icon, onClick, active, indicatorCounter, children }) => {
    const className = 'tabs-tab';

    return (
        <a className={`${className} ${className}-${name} ${active ? `${className}-active` : ''}`} onClick={onClick}>
            <span className={`${className}-icon`}>{icon}</span>
            <span className={`${className}-label`}>{children}</span>
            {indicatorCounter ? <div className={`${className}-indicator`}>{String(indicatorCounter).length > 3 ? '1k+' : indicatorCounter}</div> : null}
        </a>
    );
}

export default ({
    modules = [],
    currentModule,
    setCurrentModule,
    isTabletView,
    isTabletViewFixed,
}) => {
    const { get: getLocale } = useLocaleContext();
    const { mainMenu } = useApplicationContext();
    const { unreadMessages: unreadComments } = useCommentsContext();
    const { unreadMessages: unreadQuestions } = useQuestionsContext();
    const { unreadPolls } = usePollsContext();

    const tabsInfo = {
        comments: {
            icon: <CommentsIcon />,
            indicator: unreadComments.length
        },
        questions: {
            icon: <QuestionsIcon />,
            indicator: unreadQuestions.length
        },
        polls: {
            icon: <PollsIcon />,
            indicator: unreadPolls.length
        },
    };

    return (
        <div className={`tabs ${isTabletView ? '-tablet-view' : ''} ${isTabletViewFixed ? '-tablet-view-fixed' : ''} ${mainMenu.length < 2 ? '-not-bottom' : ''}`}>
            <span className="tabs-line"></span>
            {modules.map((module) => <Tab
                key={module}
                name={module}
                icon={tabsInfo[module]?.icon}
                indicatorCounter={tabsInfo[module]?.indicator}
                onClick={() => setCurrentModule(module)}
                active={currentModule === module}
            >
                {getLocale(`${module}.title`)}
            </Tab>
            )}
        </div>
    );
}